import { useChat } from "./chatKonteks";
import RuangChat from "./RuangChat";
import { IkonPerkecil } from "./IkonChat";

// Papan "Komputer": panel 360×520 tanpa pindah halaman.
export default function PanelChat({ konteks, onKecil }) {
  const chat = useChat();
  return (
    <section className="cht-panel" aria-label="Chat Hoonstore" data-testid="chat-panel">
      <RuangChat konteks={konteks} kepala={(
        <header className="cht-kepala is-panel">
          <span className="cht-avatar">H</span>
          <div><b>Chat Hoonstore</b><span title={chat.teks_jam}>{chat.teks_jam}</span></div>
          <button type="button" aria-label="Perkecil chat" onClick={onKecil} data-testid="chat-perkecil"><IkonPerkecil /></button>
        </header>
      )} />
    </section>
  );
}
